module.exports = __webpack_public_path__ + "static/media/v4.78d49898.jpg";